<div class="contact-form">
	<h3>Looking to Collaborate?</h3>
	<p>Whether you’re exploring a project, collaboration, <br />or just want to connect — I'd love to hear from you.</p>
	<form [formGroup]="contactForm" (ngSubmit)="sendMessage($event)">
		<div class="contact-namemail">
			<input [attr.data-content]="'Contact Name'" type="text" formControlName="name" placeholder="Name" (keydown)="trackTxtInput($event);">
			<input [attr.data-content]="'Contact Email'" type="email" formControlName="email" placeholder="Email" (keydown)="trackTxtInput($event);">
		</div>
		<input [attr.data-content]="'Contact Subject'" type="text" formControlName="subject" placeholder="Subject" (keydown)="trackTxtInput($event);">
		<textarea formControlName="msgBody" [attr.data-content]="'Contact Message'" placeholder="Your message" (keydown)="trackTxtInput($event);"></textarea>
		<div class="contact-submit">
			<div class="cs-left">
				<input name="nl-signup" type="checkbox" formControlName="nlSignup" [checked]="subscribeUser" [attr.data-content]="!subscribeUser" (change)="subscribeUser = !subscribeUser; analyticsService.trackInput($event);" /> 
				<label for="nl-signup">
					Yes, I'd like to <em>occasionally</em> receive new journal posts and updates via email.
				</label>
			</div>
			<button class="form-reset" type="button" [disabled]="!contactForm.dirty" (click)="contactForm.reset(); analyticsService.trackInput($event);">
				<img class="cf-reset" src="../../../assets/images/close-dark-tan-001.svg" width="30" alt="Contact Form Reset">
			</button>
			<button class="form-submit" type="submit" [disabled]="!contactForm.valid">Send</button>
		</div>
	</form>
</div>
<div 
	*ngIf="submitState || successState || failureState" 
	[@submitState]="submitState || successState || failureState" 
	class="cf-success"
>
	<div class="cfs-main">
		<a class="cfs-close" href="#" (click)="closeConf($event); false;"><img src="../../../../assets/images/close-gold-001.svg" width="40" alt="Contact Form Confirmation Close"></a>
		<div class="clearfix"></div>
		<p class="cfs-message" [innerHTML]="getSubmitMsg()"></p>
	</div>
</div>
